import { ProfileCommonInterface, SocialLinksCommonInterface } from '@systemeio/digital-store-shared'
import { StoreInterface } from 'modules/stores/types/stores-interface'

export const transformData = () => {
  return {
    transformProfileToStoreData: (
      tempProfile: ProfileCommonInterface,
      tempSocialLinks: SocialLinksCommonInterface[],
      store: StoreInterface,
    ) => {
      return store
        ? {
            ...store,
            profile: tempProfile,
            socialLinks: tempSocialLinks,
          }
        : store
    },
  }
}
